var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0d14040b998b1b57a3ec0e85cbebe49948c7a920"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["landing-v2@staderlabs"]={id:"0d14040b998b1b57a3ec0e85cbebe49948c7a920"};
      